export default {"src":"/_next/static/media/icon_more_bonus.636315a4.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};